<template>
  <v-container class='pa-0'>
    <h3 class="mb-3">Find a Group</h3>
    <hr class="thick" />
    <v-layout class="pa-2">
    <v-text-field
          name="searchTerm"
          v-model="searchTerm"
          append-outer-icon="search"
          label="Search for a Group"
          @click:append-outer="doSearch"
          @keyup.enter="doSearch"
        ></v-text-field>
        </v-layout>
    <hr class="thick" />

    <v-layout row wrap>

      <v-flex sm12>
        <v-list two-line class="listing">
          <p class='px-3 pt-2' v-if='searchTerm && emptyMessage'>Unfortunately, there are no results for your search.</p>
          <p class='px-3 pt-2' v-else-if='!searchTerm && emptyMessage'>Sorry, there are no groups available for you to join. Time to create a new one!</p>
          <div class='px-3 pt-2 mb-2' v-else><h3 color="secondary">Suggested Groups</h3></div>
          <template v-for="(group, index) in groups">
            <v-subheader
              v-if="group.header"
              :key="group.header"
            >
              {{ group.header }}
            </v-subheader>

            <v-list-tile
              v-else
              :key="group.name + '-' + index"
              :to="'/group/' + group.id"
              replace
            >
              <v-list-tile-content>
                <v-list-tile-title v-html="group.name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="group.description"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
.listing {
  max-height: 60vh;
  overflow-y: auto;
  background-color: #f9f5f1;
}
</style>

<script>
export default {
  data() {
    return {
      groups: {},
      searchTerm: null
    };
  },
  computed: {
    emptyMessage () {
      return this.groups.length === 0;
    }
  },
  methods: {
    doSearch() {
      this.$http.get("groups?search=" + this.searchTerm).then(
        response => {
          this.groups = response.data.data;
        },
        response => {
          console.log("Error searching.");
        }
      );
    }
  },
  mounted() {
    this.$http.get("groups/").then(
      response => {
        this.groups = response.data.data;
      },
      response => {
        console.log("Error pulling groups.");
      }
    );
  }
};
</script>
